import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import DetailsIcon from '@/svg-icons/details';

const SolicitationsSection = ({ data }) => {
  return (
    <div className="w-full">
      <div className="font-bold text-[calc(6px+0.4vw)] my-[0.6vw] flex items-center">
        <DetailsIcon 
          viewBox="0 0 34.016 34.016" 
          className="text-gray-700 mr-2 w-6 h-6 shrink-0" 
        />
        <FormattedMessage id="solicitations" />
      </div>

      <div className="flex flex-wrap text-[#858585] text-[calc(6px+0.4vw)] my-[1vw] pl-[calc(14px+1.8vw)]">
        <div className="w-1/2 mb-[1vw]" data-cy="order-details-facade-installation-date">
          <div className="font-bold">
            <FormattedMessage id="facade_installation_date" />
          </div>
          {data.facade_installation_date || '----'}
        </div>

        <div className="w-1/2 mb-[1vw]" data-cy="order-details-adhesive-installation-date">
          <div className="font-bold">
            <FormattedMessage id="adhesive_installation_date" />
          </div>
          {data.adhesive_installation_date || '----'}
        </div>

        <div className="w-1/2" data-cy="order-details-neon-installation-date">
          <div className="font-bold">
            <FormattedMessage id="neon_installation_date" />
          </div>
          {data.neon_installation_date || '----'}
        </div>
      </div>
    </div>
  );
};

SolicitationsSection.propTypes = {
  data: PropTypes.object.isRequired,
};

export default SolicitationsSection;
